import React, {useState} from 'react';
import { connect } from 'react-redux';
import {getIsFormValidating, getPasswordConfirm, getPasswordConfirmStatus} from "../../selectors";
import {changePasswordConfirmAction,} from "../../reducers";

const stateToProps = state => ({
    isFormValidating: getIsFormValidating(state),
    passwordConfirm: getPasswordConfirm(state),
    passwordConfirmStatus: getPasswordConfirmStatus(state),
});

const actionsToProps = dispatch => ({
    changePasswordConfirm: payload => dispatch(changePasswordConfirmAction(payload)),
});

const ConfirmPassword = props => {

    const [showRepeatedPassword, setShowRepeatedPassword] = useState(false);

    return (
        <div className={`form-row ${props.passwordConfirmStatus}`}>
            <label className="form-label" htmlFor="passwordConfirm">
                Confirm Password <span className="asterisk">*</span>
            </label>
            <div className={`reg-form__pass ${showRepeatedPassword ? '' : 'reg-form__pass--vision'}`}>
                <input type={showRepeatedPassword ? 'text' : 'password'} className="form-input"
                       id="passwordConfirm" onBlur={props.checkRepeatedPassword} value={props.passwordConfirm}
                       onChange={e => props.changePasswordConfirm({passwordConfirm:e.target.value})}
                       disabled={props.isFormValidating}
                />
                <span className="reg-form__pass-vision" onClick={() => setShowRepeatedPassword(!showRepeatedPassword)} />
            </div>

            <p className="callout error p10 txt-l">Passwords do not match!</p>
            <i className="form-status" />
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(ConfirmPassword);
